import React from 'react';

import PublicIcon from '@mui/icons-material/Public';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const PublishActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <PublicIcon />
    </BaseActionButton>
  );
};

export default PublishActionButton;
